const projects = require('./data/projects');

const baseTitle = 'Jay Taylor';
module.exports.titles = {
  '/projects': `Projects | ${baseTitle}`,
  '/': baseTitle,
};

module.exports.projects = projects;

module.exports.default = {};



// WEBPACK FOOTER //
// ./site/settings.js